// camelCase ↔ snake_case for the Supabase data layer.
// IMPORTANT: only TOP-LEVEL column names are converted. JSONB column *values*
// (sections, workouts, exercises, reactions, macroGoals, habits, biometrics…)
// keep their internal camelCase keys untouched — they're stored verbatim.

const toSnake = (s: string): string => s.replace(/[A-Z]/g, (m) => '_' + m.toLowerCase());
const toCamel = (s: string): string => s.replace(/_([a-z])/g, (_, c: string) => c.toUpperCase());

/** App object → DB row. Drops `undefined` so partial updates don't null columns. */
export const toRow = (obj: Record<string, any>): Record<string, any> => {
  const out: Record<string, any> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined) out[toSnake(k)] = v;
  }
  return out;
};

/** DB row → app object. */
export const fromRow = <T = any>(row: Record<string, any>): T => {
  const out: Record<string, any> = {};
  for (const [k, v] of Object.entries(row)) out[toCamel(k)] = v;
  return out as T;
};
